module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_bg_1_h5.9003a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_bg_1_h5.png
// module id = L6vO
// module chunks = 34